const { makeStyles } = require('@material-ui/core');

const useDateInputStyles = makeStyles((theme) => ({
    inputLabel: {
        fontFamily: 'var(--fontFamily)',
        fontSize: '14px',
        lineHeight: '20px',
        textAlign: 'left',
        color: '#374151',
        fontWeight: 500,
    },

    inputHelperText: {
        fontFamily: 'var(--fontFamily)',
        fontSize: '12px',
        lineHeight: '18px',
        textAlign: 'left',
        color: '#6B7280',
        fontWeight: 400,
    },

    inputFieldWrapper: {
        margin: '12px',
    },

    inputField: {
        marginTop: '6px',
        borderRadius: '8px',
        opacity: '0px',

        '& .MuiInputAdornment-root': {
            '& svg path': {
                fill: '#98A2B3',
            },
        },

        '& input': {
            padding: '9.5px 0px 9.5px 12px',
            fontSize: '16px',
        },

        '& input, & input::placeholder': {
            fontFamily: 'var(--fontFamily)',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',

            '&::placeholder': {
                color: '#98A2B3',
            },
        },
        '@media screen and (max-width: 600px)': {
            display: 'flex',
            width: '100%',
        },
    },
    footer: {
        padding: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '10px',

        '& button': {
            display: 'flex',
            textTransform: 'none',
            fontFamily: 'var(--fontFamily)',
            fontWeight: 500,
            lineHeight: '20px',
            borderRadius: '4px',
            padding: '8px 24px',
        },

        '@media (max-width: 600px)': {
            justifyContent: 'center',

            '& button': {
                flex: 1,
            },
        },
    },
    cancelBtn: {
        border: '1px solid #BFBFBF',
        color: '#171717',
    },
    applyBtn: {
        backgroundColor: '#154683',
        color: '#fff',

        '&:hover': {
            backgroundColor: '#154683',
        },
        '&:disabled': {
            backgroundColor: '#8ea2ba',
            color: '#fff',
        },
    },
    divider: {
        backgroundColor: '#EAECF0',
    },

    // Applied to the MUI Dialog paper via classes={{ paper }}. The Dialog supplies
    // the backdrop, centering and overflow the old bootstrap modal wrapper styled,
    // so only the paper box remains here.
    dialogPaper: {
        borderRadius: '16px',
        maxWidth: '350px',
        width: '100%',

        '@media screen and (max-width:600px)': {
            maxWidth: '100%',
            width: '100%',
            margin: '0px',
            borderBottomLeftRadius: '0px',
            borderBottomRightRadius: '0px',
            position: 'fixed',
            bottom: '0px',
            left: '0px',
            right: '0px',
        },
    },

    calendarWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: '8px 0',
    },
    calendar: {
        '& .react-calendar__month-view__days__day--neighboringMonth': {
            visibility: 'visible',
            color: '#8F95B2',
        },

        '& .react-calendar__month-view__days': {
            '& .react-calendar__tile--active': {
                backgroundColor: '#154683',
                borderRadius: '4px',
                color: '#ffffff',
            },

            '& .react-calendar__tile--now:not(& .react-calendar__tile--active)': {
                backgroundColor: 'transparent',
            },
        },

        '& .react-calendar__navigation': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },

        '& .react-calendar__tile:disabled': {
            backgroundColor: 'transparent',
            color: '#8F95B2',
        },

        '& .react-calendar__navigation__prev-button, & .react-calendar__navigation__next-button': {
            color: '#051B44',
            height: '32px',
            width: '32px',
            borderRadius: '4px',
            border: '1px solid #D8DAE5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '6px 10px 10px',
        },

        '& .react-calendar__navigation__label': {
            '&:hover': {
                backgroundColor: 'none',
            },

            '& span': {
                position: 'static',
            },
        },
    },
    inputErr: {
        fontFamily: 'var(--fontFamily)',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '20px',
        textAlign: 'left',
        color: '#D92D20',
        marginTop: '6px',
    },
}));

export default useDateInputStyles;
